<div class="table-presentation">

  <h1>{{settings.Title}}</h1>

  <!--img class="action-loader" *ngIf="!result || result.length == 0" src="/assets/css/images/platform/loader.gif" /-->
  @if (!result) {
    <sem-loader [showLoader]="true"></sem-loader>
  }
  @if (loadError) {
    <p class="table-presentation-error">{{errorText}}</p>
  } @else if (result && result.length == 0) {
    <p class="table-presentation-empty">{{emptyText}}</p>
  }

  <ng-scrollbar [visibility]="'hover'" [autoHeightDisabled]="false">
    @if (result && result.length > 0) {
      <div class="table-presentation-wrapper">
        <table>
          <thead>
            @for (col of settings.Columns; track col) {
              <th>
                {{col.Name}}
              </th>
            }
          </thead>
          <tbody>
            @for (data of result; track data) {
              <tr>
                @for (col of settings.Columns; track col) {
                  <td>
                    @if (col.PropType.toLowerCase() == 'string') {
                      <p>{{data[col.BindingProp]}}</p>
                    }
                    @if (col.PropType.toLowerCase() == 'datetime') {
                      <p>{{data[col.BindingProp] | date:
                      'dd.MM.yyyy'}}</p>
                    }
                    @if (!col.PropType) {
                      <p>{{data[col.BindingProp]}}</p>
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </ng-scrollbar>

</div>